import {
  fetchEvents as fetchEventsApi,
  fetchUserEvents as fetchUserEventsApi,
  createEvent as createEventApi,
  updateEvent as updateEventApi,
  getEventById as getEventByIdApi,
  getUserEventById as getUserEventByIdApi,
  deleteEvent as deleteEventApi,
} from "./SpatApi";
import { showErrorToast, showSuccessToast } from "../utils/Toasts";
import { getDataFromIndexDB, storeDataToIndexDB, clearDataFromIndexDB } from "../utils/dataStore";

const CACHE_KEY = "CACHE_UserEventDataResponse";

// Fetch all events
export async function fetchEvents() {
  try {
    const response = await fetchEventsApi();
    if (response?.status === 200) {
      return response.data;
    } else {
      showErrorToast(response?.data?.message || response?.message || "Something went wrong while fetching events");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error fetching events");
    return false;
  }
}
export async function fetchUserEvents() {

  // Check if there's a valid cached version

  const cachedData = JSON.parse(await getDataFromIndexDB(CACHE_KEY));

  if (cachedData) {
    // Use cached data if it is still valid
    return cachedData;
  }
  try {
    const response = await fetchUserEventsApi();
    if (response?.status === 200) {
      const { data } = response;
      const expiryConfig = Number(process.env.REACT_APP_CALENDAR_CACHE_EXPIRY_TIME); // in ms

      let derivedExpiry = expiryConfig;

      if (data?.lastFetchedAt) {
        const lastFetchedTime = new Date(data.lastFetchedAt).getTime();
        const expiryTime = lastFetchedTime + expiryConfig;
        const now = Date.now();
        const remaining = expiryTime - now;

        derivedExpiry = remaining > 0 ? remaining : 0;
      }

      await storeDataToIndexDB(CACHE_KEY, JSON.stringify(data), derivedExpiry);
      return data;
    }
    else if (cachedData) {
      return cachedData;
    }
    else {
      showErrorToast(response?.data?.message || response?.message || "Something went wrong while fetching events");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error fetching events");
    return false;
  }
}

export async function getUserEventById(id) {
  try {
    const response = await getUserEventByIdApi(id);
    if (response?.status === 200) {
      return response.data;
    } else {
      showErrorToast(response?.data?.message || response?.message || "Failed to fetch event data");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error fetching event details");
    return false;
  }
}

// Create new event
export async function createEvent(createEventData) {
  try {
    const response = await createEventApi(createEventData);
    if (response?.status === 200 || response?.status === 201) {
      await clearDataFromIndexDB(CACHE_KEY);
      showSuccessToast("Event created successfully");
      return true;
    } else {
      showErrorToast(response?.data?.message || response?.message || "Error creating event");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error creating event");
    return false;
  }
}

// Update event by ID
export async function updateEvent(eventId, updateEventData) {
  try {
    const response = await updateEventApi(eventId, updateEventData); // <-- Pass ID and data
    if (response?.status === 200 || response?.status === 201) {
      showSuccessToast("Event updated successfully");
      await clearDataFromIndexDB(CACHE_KEY);
      return true;
    } else {
      showErrorToast(response?.data?.message || response?.message || "Error updating event");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error updating event");
    return false;
  }
}

// Get event by ID
export async function getEventById(id) {
  try {
    const response = await getEventByIdApi(id);
    if (response?.status === 200) {
      return response.data;
    } else {
      showErrorToast(response?.data?.message || response?.message || "Failed to fetch event data");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error fetching event details");
    return false;
  }
}

export async function deleteEvent(id) {
  try {
    const response = await deleteEventApi(id);
    if (response?.status === 200) {
      showSuccessToast("Event deleted successfully");
      await clearDataFromIndexDB(CACHE_KEY);
      return true;
    } else {
      showErrorToast(response?.data?.message || "Error deleting event");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error deleting event.");
    return false;
  }
}